<template>
  <div class="first-section">
    <div class="inputs">
      <app-sel
        :disabled="textureId"
        v-model="form.textureId"
        :label="$ml.get(`Soil Texture`)"
        :filterable="true"
        :items="textures"
        key-name="id"
        label-name="name"
        @input="$store.dispatch('program/base-dressing/updateNutrients')"
      >
        <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.id">
                {{ $ml.get(item.name) }}
            </app-sel-opt>
        </template>
      </app-sel>

      <app-text-input
      :disabled="cec"
        type="number"
        :label="$ml.get('CEC')"
        v-model.number="form.cec"
        hint="meq/100g"
        min="0"
        :info-tip="$ml.get('CEC (Cation Exchange Capacity)')"
      />
    </div>

    <!-- <div class="alert" v-if="nutrientsByTexture.alert">
      {{ nutrientsByTexture.alert }}
    </div> -->

    <!-- REMEMBER IT -->
    <!-- :value="attachedSoilTest ? attachedSoilTest.data.find(x => x.type == n.label).value : nutrientsByTexture[n.label]" -->
    <!-- v-if="cec >= nutrientsByTexture.minimumCEC && cec <= nutrientsByTexture.maximumCEC" -->

    <!-- НА БУДЩЕЕ -->
    <!-- <app-text-input
      type="number"
      hint="%"
      :label="n.label"
      @input="changeValue(n.label + '_Val', $event.target.value)"
      :value="n.value"
    /> -->

    <div class="nutrients" v-if="nutrients['BDPercents']">
      <div
        class="item"
        v-for="(key, i) in sortNut"
        :key="key"
        v-if="nutrients['BDPercents'][key + '_Val'] != undefined"
        :class="{hide: !nutOpen && i > 2}"
      >
        <app-text-input
          min="0"
          max="100"
          type="number"
          hint="%"
          :label="key"
          v-model.number="nutrients['BDPercents'][key + '_Val']"
        />
      </div>

      <div class="lineBtn" @click="nutOpen = !nutOpen" :class="{open: nutOpen}">
        <svg width="10" height="6" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.86794 0.954378L3.40366 4.0521C3.16989 4.33549 2.8095 4.33549 2.58548 4.0521L0.12119 0.954378C-0.112577 0.661218 0.00430651 0.436462 0.364696 0.436462H5.62444C5.99457 0.436462 6.10171 0.661218 5.86794 0.954378Z" fill="black"/>
        </svg>
        {{$ml.get('show more nutrients')}}
      </div>


    </div>
    <div class="actions">
      <app-btn
        :loading="save_loading"
        @click="save"
      >{{$ml.get('Save')}}</app-btn>
    </div>
  </div>
</template>

<script>
import { TexturesAPI } from '@/api'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      textures: [],
      loaded: false,
      save_loading: false,
      // sortNut: ['N', 'P', 'K', 'Ca', 'Mg', 'S', 'B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo'],
      nutOpen: false,
      saveFlag: false,
      cec: null,
      textureId: null
    }
  },
  created() {
    this.selectTextures();
    // console.log(this.nutrients);
    console.log(this.computeFlag);
    if (this.form.textureId && this.form.cec)
      this.saveFlag = true;
    console.log(this.saveFlag);

    let program = this.$store.getters['program/data']
    let test = this.$store.getters['program/tests/soilTests'].find(test => {return test.id == program.soilTestId})

    this.cec = test.cec
    this.textureId = test.textureId
  },
  computed: {

    disabled(field) {
      console.log(field)
      // return field == 'cec' && this.form.cec > 0 ? true :
      //         field == 'texture' && this.form.textureId ? true :
      //         false
    },
    
    ...mapGetters({
      nutrients: 'program/base-dressing/nutrients',
      form: 'program/base-dressing/nutrientsForm',
    }),
    sortNut: function () {
      var sortNut = ['N', 'P', 'K', 'Ca', 'Mg', 'S', 'B', 'Fe', 'Cl'];

      return sortNut;

      if (this.nutOpen) {
        return sortNut;
      } else {
        return sortNut.splice(0, 3);
      }
    },
    computeFlag: function () {
      if ((this.form.textureId || this.form.cec) && this.saveFlag)
        return true;

      return false;
    }
  },
  methods: {

    

    save() {

      if(!this.form.textureId) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Select texture`),
          type: 'error',
        });
        return;
      }

      if(!this.form.cec) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Enter CEC`),
          type: 'error',
        });
        return;
      }

      this.saveFlag = true;

      this.save_loading = true;
      this.$store.dispatch('program/base-dressing/saveNutrients').then((res) => {
        this.$emit('recalculate');
      })
        .finally(() => {
          this.save_loading = false;
        });
    },
    async selectTextures() {
      this.textures = await TexturesAPI.selectAll().then(res => res.data);
    },
  },
  watch: {
    'cec': function(value) {
      // if (this.attachedSoilTest != null) {
      //   this.NPK_nutrients['BDPercents']['N_Val'] = this.attachedSoilTest.data.find(x => x.type == 'N').value;
      //   this.NPK_nutrients['BDPercents']['P_Val'] = this.attachedSoilTest.data.find(x => x.type == 'P').value;
      //   this.NPK_nutrients['BDPercents']['K_Val'] = this.attachedSoilTest.data.find(x => x.type == 'K').value;
      // } else if (value >= this.nutrientsByTexture.minimumCEC && value <= this.nutrientsByTexture.maximumCEC) {
      //   this.NPK_nutrients['BDPercents']['N_Val'] = this.nutrientsByTexture.N;
      //   this.NPK_nutrients['BDPercents']['P_Val'] = this.nutrientsByTexture.P;
      //   this.NPK_nutrients['BDPercents']['K_Val'] = this.nutrientsByTexture.K;
      // } else {
      //   this.NPK_nutrients['BDPercents']['N_Val'] = 0;
      //   this.NPK_nutrients['BDPercents']['P_Val'] = 0;
      //   this.NPK_nutrients['BDPercents']['K_Val'] = 0;
      // }
    },
    computeFlag: function (val) {
      this.$emit('input', true);
    }
  },
}
</script>

<style lang="scss" scoped>

.first-section {

  // padding: 0 48px;
  // padding-top: 50px;
  .actions {
    margin-top: 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: flex-end;
  }
  .heading {
    padding-bottom: 40px;
  }

  .inputs {

    display: flex;
    flex-direction: row;
    align-items: center;

    padding-bottom: 40px;

    .app-sel {
      width: 300px;
      margin-right: 50px;
    }

  }

  .nutrients {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow: auto;
    margin-right: -16px;
    margin-left: -16px;
    padding-top: 24px;
    transition: all 1s;

    .lineBtn {
      width: 100%;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
      background: #F9F9F9;

      svg {
        transition: all 1s;
      }

      &.open svg {
        transform: rotate(180deg);
      }
    }

    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      flex-basis: calc(33% - 32px);
      font-size: 16px;
      margin: 0 16px;
      margin-bottom: 20px;
      overflow: hidden;
      padding-top: 22px;
      transition: max-height .5s ease,  padding-top .5s ease, margin-top .5s ease, margin-bottom .5s ease;

      &.hide {
        max-height: 0;
        padding-top: 0;
        margin-top: 0;
        margin-bottom: 0;
      }

      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        // padding-right: 50px;
      }

      .name {
        // height: 40px;
        font-weight: 500;
        padding-bottom: 4px;
        // border-bottom: 1px solid silver;
      }

      .value {
        // height: 40px;

        input {
          width: 100%;
          // height: 40px;
          padding: 8px;
          color: #568129;
        }
      }
    }
  }
  @media (max-width:768px) {
    .inputs {
      flex-direction: column;
      align-items: flex-start;
      padding-bottom: 0;
      > div {

        &.app-sel {
          margin-right: 0;
          width: 100%;
          margin-bottom: 32px;
        }
      }
    }
    .nutrients {
      margin-right: 0;
      margin-left: 0;
      padding-top: 0;
      justify-content: space-between;
      .item {
        flex-basis:30%;
        margin: 32px 0 0px 0;
      }
    }
  }
}

</style>
